/**
 * @file skillConstants.js
 * @description Constants for the Skill management module within the Admin section.
 *              Includes UI label strings, skill type enums, data field key mappings,
 *              table column definitions, column key mappings, user-facing messages,
 *              and error message strings.
 *
 * @module skillConstants
 *
 * @exports SKILL_STRINGS           - UI label strings (e.g. "Add Skill", "Edit Skill", "Is Voice").
 * @exports SKILL_TYPES             - Enum for skill channel types: Chat, Calls.
 * @exports SKILL_KEYS              - Enum-style keys for skill data fields.
 * @exports SKILL_TABLE_COLUMNS     - Column config array for the skills table.
 * @exports SKILL_TABLE_COLUMN_KEYS - Enum-style keys matching table column IDs.
 * @exports SKILL_MESSAGES          - User-facing success/empty-state messages.
 * @exports SKILL_ERRORS            - Error message strings for CRUD operations.
 */
export const SKILL_STRINGS = {
    ADD_SKILL: "Add Skill",
    EDIT_SKILL: "Edit Skill",
    SKILL_NAME: "Skill Name",
    SEARCH_SKILLS: "Search Skills",
    ENABLE_QUEUEID: "Enable Queue ID",
    IS_VOICE: "Is Voice",
    VOIP: "Voip",
    CHAT: "Chat",
};

export const SKILL_TYPES = {
    CHAT: "Chat",
    CALLS: "Calls",
}

export const SKILL_KEYS = {
    ID: "id",
    SKILL_NAME: "skillname",
    INACTIVE: "inactive",
    QUEUE_ID: "queueid",
    QUEUE_ID_REQUIRED: "queueIdreq",
    IS_VOICE: "isVoice"
};

export const SKILL_TABLE_COLUMNS = [
    { id: "actions", isSortable: false, label: "Actions" },
    { id: "id", isSortable: true, label: "Skill ID" },
    { id: "skillname", isSortable: true, label: "Skill Name" },
    { id: "queueid", isSortable: true, label: "Queue ID" },
    { id: "isVoice", isSortable: true, label: "Channel Type" },
    { id: "CreateDate", isSortable: true, label: "Create Date" },
    { id: "active", isSortable: false, label: "Active" },
];

export const SKILL_TABLE_COLUMN_KEYS = {
    ID: "id",
    ACTIONS: "actions",
    SKILL_NAME: "skillname",
    QUEUE_ID: "queueid",
    CHANNEL_TYPE: "isVoice",
    CREATE_DATE: "CreateDate",
    ACTIVE: "active"
};

export const SKILL_MESSAGES = {
    NO_SKILLS: "No skills to display",
    SKILL_ADDED: "Skill added successfully!",
    SKILL_UPDATED: "Skill updated successfully!",
};

export const SKILL_ERRORS = {
    ADD_SKILL_ERROR: "Error adding skill:",
    SAVE_SKILL_ERROR: "Error saving skill:",
    UPDATE_SKILL_ERROR: "Error updating skill:",
    FETCH_SKILLS_ERROR: "Error fetching user skills:",
};